import { Chip } from "@mui/material";
import { FulfillmentStatus } from "@lib/ShiOneClient";
import { getOrderStatusChip } from "@features/orders-features/components/orderStatusChips";
import { TrackingDrawer } from "shared-ui/src/components/detail-drawer/TrackingDrawer";
import type { TrackingHistoryEvent } from "shared-ui/src/components/detail-drawer/TrackingDrawer";
import type { StackedDrawerProps } from "shared-ui/src/components/detail-drawer/drawer-stack/types";
import { useGetShipmentTracking } from "@features/orders-features/hooks/useGetShipmentTracking";

export interface StackedTrackingDrawerProps extends StackedDrawerProps {
  trackingNumber: string;
  carrier: string;
  trackingUrl: string;
  shippedOn?: Date | null;
  deliveryOn?: Date | null;
  status?: string;
  salesOrder?: string;
  purchaseOrder?: string;
  biOrderId?: number | null;
  receivedBy?: string | null;
  shipToName?: string | null;
  shipToCompany?: string | null;
  shipToAddress?: string[];
}

export function StackedTrackingDrawer({
  open,
  onClose,
  onCloseAll,
  zIndex,
  depth,
  trackingNumber,
  carrier,
  trackingUrl,
  shippedOn,
  deliveryOn,
  status,
  salesOrder,
  purchaseOrder,
  biOrderId,
  receivedBy,
  shipToName,
  shipToCompany,
  shipToAddress,
}: StackedTrackingDrawerProps) {
  const { data: trackingData } = useGetShipmentTracking(biOrderId, trackingNumber);

  const history: TrackingHistoryEvent[] =
    trackingData?.trackingHistory?.map((e) => ({
      updateDate: e.updateDate?.toISOString() ?? null,
      status: e.status ?? "",
      location: e.location ?? "",
    })) ?? [];

  const statusKey = status?.replace(/\s+/g, "") as FulfillmentStatus | undefined;
  const { color, icon, iconColor, borderColor } = getOrderStatusChip(statusKey);

  return (
    <TrackingDrawer
      open={open}
      onClose={onClose}
      onCloseAll={onCloseAll}
      zIndex={zIndex}
      depth={depth}
      trackingNumber={trackingNumber}
      carrier={trackingData?.carrier ?? carrier}
      trackingUrl={trackingUrl}
      shippedOn={shippedOn}
      deliveryOn={deliveryOn}
      status={status}
      statusChip={
        status ? (
          <Chip
            icon={icon}
            label={status}
            size="small"
            variant="outlined"
            sx={{
              borderColor: borderColor ?? color,
              color,
              "& .MuiChip-icon": { color: iconColor ?? color },
            }}
          />
        ) : undefined
      }
      salesOrder={salesOrder}
      purchaseOrder={purchaseOrder}
      weight={trackingData?.weight}
      receivedBy={receivedBy}
      shipToName={shipToName}
      shipToCompany={shipToCompany}
      shipToAddress={shipToAddress}
      trackingHistory={history}
    />
  );
}

